import styled from 'styled-components';

import { CenterCell } from '../../../assets/styles/sharedStyles/sharedStyles';

export const FileNameCell = styled(CenterCell)`
  display: flex;
  flex-direction: row;

  p {
    width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .icon {
    margin-left: auto;
  }
`;
